import { Menu, MenuItem } from "@material-ui/core";
import React from "react";
import EditIcon from "@material-ui/icons/Edit";

const MenuManageEmailTemplate = ({
  idManageEmails,
  item,
  anchorSelected,
  anchorEl,
  setAnchorEl,
  setAnchorSelected,
  handleEditEmail,
  handleCloseActions,
}) => {
  return (
    <Menu
      id="long-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorSelected === idManageEmails ? true : false)}
      keepMounted
      transition={"true"}
      onClose={() => handleCloseActions()}
    >
      <MenuItem
        onClick={() => {
          setAnchorEl(null);
          setAnchorSelected(null);
          handleEditEmail(item);
        }}
      >
        <EditIcon />
        &nbsp; Edit
      </MenuItem>
    </Menu>
  );
};

export default MenuManageEmailTemplate;
